import { AUTH_TOKEN } from "~/application/constants/storageKeys";

export function getAuthToken(): string {
  return (
    sessionStorage.getItem(AUTH_TOKEN) || localStorage.getItem(AUTH_TOKEN) || ""
  );
}
